import { useEffect, useRef } from "react";

import { SuggestionProps } from "./suggestion";
import hashtagSuggestion from "./suggestion/hash-suggest";

// You can extend this to also support hashtag suggestions similarly
export function useHashTagSuggestions(suggestions: SuggestionProps[]) {
  const suggestionRef = useRef<SuggestionProps[]>(suggestions);

  useEffect(() => {
    suggestionRef.current = suggestions;
  }, [suggestions]);

  return hashtagSuggestion(suggestionRef);
}
